import { render, staticRenderFns } from "./EditLists.vue?vue&type=template&id=9b2ea4a6&scoped=true"
import script from "./EditLists.vue?vue&type=script&lang=js"
export * from "./EditLists.vue?vue&type=script&lang=js"
import style0 from "./EditLists.vue?vue&type=style&index=0&id=9b2ea4a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b2ea4a6",
  null
  
)

export default component.exports